var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "job-preview-right-column",
        _vm._g(
          {
            attrs: {
              "text-count-mode": _vm.textCountMode,
              "highlight-mode": _vm.highlightMode,
              "comment-class": "feature",
              "comment-highlights": _vm.commentHighlights,
            },
          },
          _vm.$listeners
        )
      ),
      _vm._v(" "),
      _c("div", { staticClass: "feature-block fll" }, [
        _c("p", { staticClass: "h-style-03 fs13 fwB" }, [
          _vm._v("\n      働く環境の特徴\n    "),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "environment" }, [
          _c("img", {
            staticClass: "environment-background",
            attrs: {
              src: _vm.userOfferImageUrlForPc + "/environment_bg.png",
              "data-test": "environment-background",
            },
          }),
          _vm._v(" "),
          _c(
            "ul",
            _vm._l(
              _vm.requirements.features.environments,
              function (environment) {
                return _c(
                  "li",
                  {
                    key: "environment-star-" + environment.id,
                    class: "enviro-star-0" + environment.name,
                    attrs: {
                      id: _vm.targetIdMap.feature.environment[environment.id],
                      "data-test": "environment-star-" + environment.id,
                    },
                  },
                  [
                    _c("img", {
                      attrs: {
                        src:
                          _vm.userOfferImageUrlForPc + "/feature_star_img.png",
                      },
                    }),
                  ]
                )
              }
            ),
            0
          ),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "feature-block flr" }, [
        _c("p", { staticClass: "h-style-03 fs13 fwB" }, [
          _vm._v("\n      この仕事の特徴\n    "),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "work-feature" }, [
          _c("img", {
            staticClass: "work-feature-background",
            attrs: {
              src: _vm.userOfferImageUrlForPc + "/work_feature_bg.png",
              "data-test": "work-feature-background",
            },
          }),
          _vm._v(" "),
          _c(
            "ul",
            _vm._l(_vm.requirements.features.work, function (work) {
              return _c(
                "li",
                {
                  key: "work-feature-bar-" + work.id,
                  attrs: {
                    id: _vm.targetIdMap.feature.work[work.id],
                    "data-test": "work-feature-bar-" + work.id,
                  },
                },
                [_c("span", { class: "work-feature-bar-0" + work.name })]
              )
            }),
            0
          ),
        ]),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }